/** Tabs of GTM Settings, kept in the URL (`?tab=`); general when unset. */
export const GTM_SETTINGS_TABS = ['general', 'emails', 'sending'] as const

export type GtmSettingsTab = (typeof GTM_SETTINGS_TABS)[number]
